










import { Component, Vue } from 'vue-property-decorator'
import { VQuery, VTable, QueryModel, TableHander, TableOperation } from '@/components/table'
import { QueryConfigLIst,RemoveSysConfig } from '@/api'
import { DateFormat } from '@/utils/date/DateUtil'
import { Message, MessageBox } from 'element-ui'
import EdittSysConfigDialog from './components/EdittSysConfigDialog.vue'

@Component({
  components: {
    VQuery,
    VTable,
    EdittSysConfigDialog,
  },
})
export default class SysConfigList extends Vue {
  private queryParam = {
    startRow: 1,
    limit: 10,
  }
  private tableTotal = 0
  private tableData = []
  private tableCurrntPage = 1

  // 查询条件
  private queryModels: Array<QueryModel> = [
    { title: '参数', param: 'configParam' },
  ]
  // 全局操作
  private queryOperation: Array<TableOperation> = [
    { title: '新建', type: 'primary', click: this.createHandle },
  ]
  // 数据表头
  private tableHander: Array<TableHander> = [
    { title: '序号', param: 'id', type: 'index' },
    { title: '参数', param: 'configParam' },
    { title: '值', param: 'configValue' },
    { title: '备注', param: 'note' },
    { title: '创建时间', param: 'createTime', formatter: DateFormat },
    {
      title: '操作',
      width: 150,
      operation: [
        { title: '修改', icon: 'el-icon-edit', click: this.openUpdate},
        { title: '删除', icon: 'el-icon-delete', class: 'red', click: this.deleteRow },
      ],
    },
  ]

  public async created() {
    this.loadData()
  }

  public createHandle() {
    (this.$refs.EdittSysConfigDialog as EdittSysConfigDialog).open('add')
  }

  public openUpdate(data: any) {
    (this.$refs.EdittSysConfigDialog as EdittSysConfigDialog).open('update',data.id)
  }

  // 删除单行数据
  public deleteRow(data: any) {
    console.log(data)
    MessageBox.confirm('确定要删除吗？', '提示', {
      type: 'warning',
    }).then(async () => {
      const ruslt = await RemoveSysConfig({ id: data.id })
      if (ruslt) {
        Message.success('删除成功')
        this.loadData()
      }
    })
  }

  public async loadData() {
    const param = { ...this.queryParam }
    param.startRow =  (this.tableCurrntPage - 1) * (param.limit || 12)
    const result = await QueryConfigLIst(param)
    this.tableTotal = result.total
    this.tableData = result.list
  }

  public search() {
    console.log(this.queryParam)
    this.tableCurrntPage = 1
    this.loadData()
  }
  // 分页导航改变
  public pageChange(index: number) {
    this.tableCurrntPage = index
    this.loadData()
  }

  public sizeChange(index: number) {
    this.tableCurrntPage = 1
    this.queryParam.limit = index
    this.loadData()
  }

  // 删除单行数据
  // public deleteRow(data: any) {
  //   MessageBox.confirm('确定要删除吗？', '提示', {
  //     type: 'warning',
  //   }).then(async () => {
  //     const ruslt = await DeleteActivity({ id: data.id })
  //     if (ruslt) {
  //       Message.success('删除成功')
  //       this.loadData()
  //     }
  //   })
  // }
}
